
import { screenShareAction } from '../interface/meetReducerTypes';
import { sharingState } from '../models/meetModal';

const initialState = {
    isSuccess: false,
    sharingStatus: false,
    conId: '',
    annotation:[],
    annotationEnable:false,
    annotationPopup:false,
    remoteVideoSize:{}
};

const sharingReducerState = (state: sharingState = initialState, action: any) => {
    const {
        type,
        payloads,
        connId
    } = action;
    switch (type) {
        case 'SCREENSHARING_STATUS':
            return {
                ...state, sharingStatus: payloads, conId: connId
            };
        case 'ANNOTATE':
            return{
                ...state,annotation:payloads.annotation,annotationCopy:payloads.annotationCopy
            }
        case 'RESIZE_CANVAS':
            console.log("resizeee payloaddd",payloads)
            return{
               ...state,remoteVideoSize:payloads.remoteVideoSize
        }
        case 'ANNOTATION_STATUS':
            return{
               ...state,annotationEnable:payloads.annotationEnable,annotationPopup:payloads.annotationPopup
        }
        default:
            return state;
    };
};

export default sharingReducerState;